/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Month from './Month/index'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2LeftArrowLongCircle from 'DesignSystem/Svgs/Tysiav2LeftArrowLongCircle/index'
import Tysiav2RightArrowLongCircle from 'DesignSystem/Svgs/Tysiav2RightArrowLongCircle/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthAndYearSelector/Dropdown/Content",
  closePopover
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover
  
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dropdownDateValueData = fromData.useDataValue({ viewPath,
context: 'dropdown',
path: 'date',
})
let constantData = 'yyyy'
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromFormat.formatTzDate(dropdownDateValueData, constantData, tabSelectedTimeZoneIdValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover
  
})
let dropdownMonthsValueData = fromData.useDataValue({ viewPath,
context: 'dropdown',
path: 'months',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-7-Z1Yf8zk': dtColorsNeutral100,'--bc-8-Z1Yf8zk': dtColorsWhite}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 id="prev"
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-5-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-6-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<Tysiav2LeftArrowLongCircle
{...childProps}
  viewPath={`${viewPath}/Tysiav2LeftArrowLongCircle`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral500}
/>
)}
</TysiaButtonIcon>
</button>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 fontSize={dtTypographyFontsizeMm}
 marginLeft="auto"
 marginRight="auto"
 weight="medium"
 data="dropdown.date"
 data="'yyyy'"
 data="tab.selected.time_zone_id"
 aggregate="/Data/format.js formatTzDate"
 text={aggregateData}
/>
<button
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 id="next"
 {...isHoveredBind}
 onClick={onClick1}
 style={{'--pt-5-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-6-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 type="primary"
>
{childProps => (
<Tysiav2RightArrowLongCircle
{...childProps}
  viewPath={`${viewPath}/Tysiav2RightArrowLongCircle`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral500}
/>
)}
</TysiaButtonIcon>
</button>
</div>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(dropdownMonthsValueData) && dropdownMonthsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="dropdown_month"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Month(${item?.id ?? item?._id ?? index})`}
      >
<Month
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Month(${item?.id ?? item?._id ?? index})`}
 closePopover={closePopover}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }